import { a as e, i as t, n, o as r, r as i, s as a, t as o } from "./chunks/errors-BJxlOkXf.js";
//#region src/core/stable.ts
function s(e, t = 0) {
	return JSON.stringify(c(e), null, t);
}
function c(e) {
	return Array.isArray(e) ? e.map(c) : e && typeof e == "object" ? Object.fromEntries(Object.entries(e).filter(([, e]) => e !== void 0).sort(([e], [t]) => e.localeCompare(t)).map(([e, t]) => [e, c(t)])) : e;
}
function l(e = "cmd") {
	return `${e}-${globalThis.crypto?.randomUUID?.() ?? `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`}`;
}
function u(e) {
	let t = e.trim().toUpperCase();
	if (!/^[A-Z][A-Z0-9_]{1,63}$/.test(t)) throw Error("applicationCode 必须是 2-64 位大写稳定编码");
	return t;
}
function d(e) {
	let t = e.trim();
	if (!t.startsWith("/") || t.includes("..")) throw Error("basePath 必须是站内绝对路径且不能包含 ..");
	return t.replace(/\/+$/, "") || "";
}
//#endregion
//#region src/core/trace.ts
function f(e) {
	return Object.freeze({
		traceId: e?.trim() || l("trace"),
		requestId: l("request")
	});
}
//#endregion
export { o as FORM_SESSION_ERRORS, n as PORTAL_FORM_SESSION_ERRORS, i as PlatformSdkError, l as createPublicId, f as createTraceContext, t as formSessionError, u as normalizeApplicationCode, d as normalizeBasePath, e as portalFormSessionError, r as sanitizeDetails, s as stableStringify, a as toPlatformError };
